/**
 * Mapeo de NIT de empresa a tipo de conecta (ruta).
 * Este archivo NO debe importar componentes Angular para evitar dependencias circulares.
 * Importado por: load.service
 */
export const CONECTAS_ROUTE_MAP: Record<string, string> = {
  '901780224': 'creditos365',
  '890903938': 'bancolombia',
  // Futuros: '9012345xx': 'nuevo-aliado'
};
